import axios from 'axios';

const baseDomain  = "http://fakerestapi.azurewebsites.net";
const baseURL  = `${baseDomain}/api`;


export const endpoints = {
    'login'         :       '/login',
    'signup'        :       '/singnup',
    'activities'    :       '/Activities',
    'authors'       :       '/Authors',
    'books'         :       '/Books',
    'users'         :       '/Users',
};


// Create axios instance
const api = axios.create({baseURL: baseURL, withCredentials: false});



export default api;
